import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationError, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'portal-front-end';

  constructor(router: Router, snackBar: MatSnackBar) {
    router.events
      .pipe(filter((event): event is NavigationError => event instanceof NavigationError))
      .subscribe(event => {
        console.error('Navigation error:', event.error);
        snackBar.open('This page could not be loaded. Please try again.', 'Close', { duration: 10000, horizontalPosition: 'end' });
      });
  }
}
